import { useLang } from "../context/LanguageContext";
import { QuotationForm } from "../components/QuotationForm";

export default function Quotation() {
  const { t } = useLang();
  return (
    <div data-testid="quotation-page">
      <section className="bg-[#0891b2] text-white py-16">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <p className="text-[11px] tracking-[0.3em] text-red-200 mb-4 font-semibold">{t.quotation.eyebrow}</p>
          <h1 className="font-display text-4xl sm:text-5xl leading-tight" data-testid="quotation-title">{t.quotation.title}</h1>
          <p className="text-cyan-100 mt-3 max-w-2xl">{t.quotation.subtitle}</p>
        </div>
      </section>

      <section className="py-12 sm:py-16">
        <div className="max-w-3xl mx-auto px-6">
          <div className="bg-white border border-slate-200 rounded-lg p-6 sm:p-10 shadow-sm">
            <QuotationForm />
          </div>
        </div>
      </section>
    </div>
  );
}
